import { createSelector } from 'reselect'
import { State } from 'index'

const tagSelector = (state: State) => state.tag

export const getTags = createSelector([tagSelector], (state) => state.tags)
